import { forwardRef } from 'react';
import { motion } from 'framer-motion';
var circleVariant = {
    initial: {
        scale: 0,
    },
    visible: {
        scale: 1,
        transition: {
            delay: 0.4,
        },
    },
    exit: {
        scale: 0,
    },
};
var container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.02,
        },
    },
};
var ReassuranceWrapper = forwardRef(function (_a, ref) {
    var children = _a.children;
    return (<div ref={ref} className="dark relative flex grid h-full w-[40%] grid-cols-6 items-center overflow-auto bg-secondary-01-light lg:items-start xl:w-[35%] max-lg:hidden ">
        <motion.div className="absolute top-0 right-0 aspect-square w-[110%] origin-top-right rounded-bl-full bg-secondary-01" variants={circleVariant} initial="initial" animate="visible"/>
        <motion.div className="z-1 col-start-2 col-end-6 flex flex-col gap-10 gap-10 overflow-hidden py-10" variants={container} initial="hidden" animate="show">
          {children}
        </motion.div>
      </div>);
});
export default ReassuranceWrapper;
